var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOrdinancesReady = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 162,
    viewBox: "0 0 308 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_34588)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 308,
    height: 162,
    fill: "#FFF9E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.508 72.1741C297.291 73.8412 309.186 70.5312 308.893 72.1741C308.706 73.2285 318.394 97.5783 318.176 98.6227C316.223 107.983 328.862 107.84 324.657 116.138C322.386 120.623 318.051 130.029 315.198 134.127H-188.088L-205.641 109.579C-205.641 109.579 -231.093 57.1214 -224.285 53.6631C-219.929 51.4504 -169.453 71.0956 -166.133 69.3715C-136.444 53.9585 -94.7632 52.8594 -88.3811 53.6631C-83.3085 54.3029 -71.8994 47.4662 -67.1844 44.4683C-65.9291 43.6703 -63.6948 42.0274 -61.1072 44.4882C-57.8998 47.5403 -48.9771 51.0299 -44.8578 53.3824C-39.295 56.5599 -30.3424 63.1614 -24.8566 59.5365C-19.3708 55.9116 -8.58717 45.0468 -3.46042 46.0969C1.66634 47.1471 21.7773 59.441 24.8693 62.3962C27.9627 65.3515 46.6402 77.4473 61.5745 77.4687C76.5102 77.4887 87.5217 80.6063 94.4054 82.0811C103.258 83.9777 127.876 80.4018 134.437 82.0811C138.115 81.1841 151.345 74.5394 156.506 77.4687C165.439 73.7505 166.694 68.4267 173 66.5C188.063 69.6528 185.492 69.9256 195.741 70.4225C208.612 71.0465 234.629 59.0423 240.199 59.5365C250.203 60.4228 283.495 69.3715 283.495 69.3715L297.508 72.1741Z",
    fill: "#FFEFBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.821 87.7296C298.556 90.3901 390.868 85.3532 326.231 97.97C324.277 107.33 314.847 112.787 310.642 121.086H-201.692L-203.969 113.861C-203.969 113.861 -214.322 112.866 -207.822 111.759C-197.127 109.937 -235.497 87.7628 -212.727 83.7341C-203.44 80.3307 -189.576 104.422 -169.288 109.657C-152.225 114.061 -123.355 110.015 -117.091 111.759C-97.0738 117.332 -64.4486 110.447 -51.9323 113.861C-39.4161 117.275 0.77243 105.267 15.503 100.899C30.2335 96.5305 52.0302 78.0944 65.2475 83.7341C78.4662 89.3753 73.0181 85.3861 85 90.5C96.9819 95.6139 109.533 91.7308 119.759 93.8838C129.259 95.8838 131.259 92.8838 140.759 91.3838C165.281 91.3838 172.642 89.9191 175.906 89.2734C191.846 86.121 199.133 76.357 205.373 79.7054C219.616 87.3482 236.089 77.9561 243.032 77.0782C244.888 77.0495 285.604 87.7497 286.821 87.7296Z",
    fill: "#FFE287"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -291.721,
    y: 120.517,
    width: 600.088,
    height: 47.993,
    fill: "#FFD357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.432 312.891C322.531 314.31 322.687 315.741 322.715 317.16L322.729 321.368L322.715 322.42V322.946L322.673 323.606L322.418 326.297C321.471 333.453 318.259 340.34 314.03 345.783C309.786 351.287 304.778 355.728 299.629 359.483C289.246 366.908 278.311 371.996 267.377 376.363C256.428 380.693 245.38 384.167 234.318 387.225C223.256 390.296 212.165 392.901 201.061 395.25C178.852 399.947 156.6 403.555 134.321 406.687C89.761 412.864 45.1591 416.974 0.557129 420.203C-44.0448 423.408 -88.6468 425.634 -133.249 427.286C-215.535 430.286 -297.779 431.326 -380 431.241V387.45C-298.161 389.366 -216.29 390.141 -134.564 388.975C-90.4009 388.326 -46.294 387.103 -2.31448 384.926C41.6509 382.724 85.5172 379.654 128.818 374.626C150.447 372.082 171.963 369.073 193.012 365.11C203.522 363.128 213.948 360.939 224.104 358.358C234.261 355.801 244.206 352.902 253.542 349.44C262.864 346.015 271.691 341.979 278.566 337.269C281.975 334.933 284.804 332.438 286.799 329.991C287.351 329.38 287.69 328.768 288.157 328.181C288.454 327.569 288.921 326.982 289.133 326.395C289.769 325.221 290.038 324.059 290.307 322.884C290.333 322.608 290.37 322.342 290.408 322.068L290.42 321.979L290.463 321.747L290.477 321.368L290.491 320.622L290.59 317.637C290.59 316.646 290.505 315.692 290.477 314.713L290.406 313.258L290.222 311.839C289.869 308.022 288.864 304.451 287.492 301.062C284.804 294.261 279.825 288.451 273.134 283.424C269.796 280.892 265.905 278.678 261.803 276.623C257.701 274.555 253.245 272.745 248.605 271.118C239.354 267.828 229.31 265.357 219.04 263.265C198.401 259.167 176.73 256.758 154.804 254.495C143.841 253.369 132.779 252.293 121.617 251.057C110.471 249.822 99.2104 248.415 87.8513 246.483C82.1788 245.541 76.4497 244.379 70.7065 243.009C64.9633 241.627 59.1634 240.012 53.3636 237.822C47.5779 235.645 41.7216 232.942 36.2047 229.125C30.702 225.333 25.5953 220.086 22.554 213.86C21.7052 212.343 21.2242 210.716 20.6584 209.126C20.3472 208.331 20.1916 207.523 20.0218 206.716L19.5126 204.306C19.3004 202.704 19.2014 201.126 19.1023 199.536C19.1448 197.995 19.1024 196.478 19.3004 194.912C19.4701 193.346 19.6682 191.781 20.0784 190.203C20.3896 188.625 20.9696 187.059 21.5213 185.493C22.7944 182.423 24.407 179.365 26.5855 176.698C27.0806 176.001 27.6465 175.353 28.2265 174.729C28.8065 174.105 -5.60828 171.099 -5 170.5C-3.74103 169.35 -5 160.081 -2.5 163.5C-1 162 1.9725 161.415 6.5 160C14.5 157.5 31.5 155.92 43.5 154C56 152 72 150.5 84 149.5L85.785 149.429C98.3313 148.928 116.97 148.184 127.587 147.39C149.824 145.715 171.864 144.553 193.167 141.69C203.791 140.235 214.259 138.363 223.906 135.415C228.73 133.947 233.328 132.198 237.458 130.07C241.603 127.966 245.252 125.47 248.053 122.559C248.751 121.899 249.326 121.186 249.905 120.469L250.034 120.308C250.67 119.562 251.236 118.657 251.802 117.825C252.863 116.137 253.669 114.449 254.207 112.81H270.948C270.799 113.975 270.568 115.118 270.262 116.223C269.399 119.232 268.126 122.021 266.613 124.59C265.821 125.85 265.085 127.061 264.137 128.284L264.137 128.285C263.203 129.508 262.27 130.73 261.195 131.831C257.008 136.406 251.873 140.002 246.554 142.889C241.221 145.776 235.662 148.014 230.074 149.873C218.87 153.555 207.554 155.794 196.308 157.604C173.816 161.127 151.508 162.778 129.596 164.919C118.633 165.983 107.783 167.145 97.1877 168.699C86.6207 170.264 76.2093 172.222 66.873 175.218C62.219 176.711 57.8761 178.484 54.1841 180.564C52.3875 181.628 50.6618 182.717 49.2896 183.915C48.5258 184.49 47.9599 185.139 47.3092 185.726C46.998 186.044 46.7575 186.374 46.4746 186.68C46.1917 186.986 45.9229 187.304 45.7249 187.646C44.7064 188.918 44.0981 190.313 43.5181 191.744C43.3201 192.49 43.023 193.212 42.924 194.019C42.726 194.778 42.6835 195.609 42.5987 196.429C42.3299 199.976 42.9806 203.059 44.3669 205.64C45.7674 208.221 47.9883 210.557 51.2135 212.685C54.4388 214.789 58.4844 216.624 62.9121 218.165C67.3398 219.731 72.1777 220.979 77.1429 222.055C82.1364 223.119 87.2571 224.049 92.5052 224.795C113.484 227.853 135.495 229.284 157.675 231.095C179.87 232.893 202.405 234.838 225.194 238.825C236.581 240.88 248.053 243.388 259.469 247.131C265.17 248.99 270.857 251.131 276.444 253.761C282.003 256.391 287.52 259.351 292.684 263.033C297.847 266.678 302.685 270.898 306.872 275.693C311.073 280.463 314.468 285.87 316.958 291.46C319.448 297.05 321.159 302.873 321.923 308.597C322.036 309.319 322.164 310.041 322.248 310.75L322.432 312.891Z",
    fill: "#FFBF09"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.362,
    y: 128.574,
    width: 93.8841,
    height: 8.40753,
    rx: 4.20377,
    fill: "#F1AB0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.462 73.7728H226.916V75.6684H225.908V73.7728H224.662V75.6684H223.653V73.7728H222.411V75.6684H221.403V73.7728H206.29V132.414H269.881V73.7728H254.978V75.6684H253.97V73.7728H252.726V75.6684H251.718V73.7728H250.471V75.6684H249.462V73.7728Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.249 36.9393L238.239 13.3776L234.228 36.9393H233.369V36.2128H233.359L232.624 32.6885L231.889 36.2128H231.879V36.9393V39.6956V46.1271H231.872V43.2201H231.859L231.124 39.6958L230.389 43.2201H230.381V46.1271H230.372V51.4864L229.469 48.0807L228.285 52.5446H228.256V56.1336V56.9918V132.413H248.214V56.9918H248.216V52.5446H248.192L247.008 48.0807L245.824 52.5446H245.796V56.1336H245.793V46.1271H245.78V43.2201H245.769L245.034 39.6957L244.299 43.2201H244.292V39.6956H244.302V36.2128H244.288L243.553 32.6885L242.818 36.2128H242.812V36.9393H242.249Z",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.511 4.33973L237.736 6.75473C237.852 6.69689 238.109 6.61592 238.213 6.75473C238.226 6.77117 238.239 6.78812 238.253 6.80577C238.384 6.97442 238.565 7.20619 238.474 7.65129L239.327 8.47556L239.471 9.92165L238.734 10.9628V13.0018L238.474 13.3778H237.866V12.9295L237.23 12.2788L236.999 11.1942V7.96943L236.493 7.4633L236.811 6.11844L235.35 4.51329C235.254 4.47955 235.014 4.43231 234.829 4.51329L235.511 3.86255C235.47 3.97712 235.412 4.23296 235.511 4.33973ZM237.033 6.35509L237.634 6.85982C237.555 7.01017 237.445 7.37102 237.634 7.61157L237.496 7.7297L236.905 7.32162L237.033 6.35509Z",
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.319,
    cy: 85.4308,
    r: 1.81506,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.319,
    cy: 109.113,
    r: 1.81506,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.158,
    cy: 85.4308,
    r: 1.81506,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.158,
    cy: 109.113,
    r: 1.81506,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.123 67.5398C236.123 66.4322 237.068 65.5343 238.234 65.5343C239.4 65.5343 240.346 66.4322 240.346 67.5398H240.347V79.6402H236.123V67.5398C236.123 67.5398 236.123 67.5398 236.123 67.5398Z",
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.089 87.0572C241.089 87.0571 241.089 87.057 241.089 87.057C241.089 85.5596 239.812 84.3457 238.235 84.3457C236.659 84.3457 235.381 85.5596 235.381 87.057C235.381 87.057 235.381 87.0571 235.381 87.0572H235.381V103.416H241.091V87.0572H241.089Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.089 110.832C241.089 110.832 241.089 110.832 241.089 110.832C241.089 109.334 239.812 108.12 238.235 108.12C236.659 108.12 235.381 109.334 235.381 110.832C235.381 110.832 235.381 110.832 235.381 110.832H235.381V127.191H241.091V110.832H241.089Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.697 95.8993C253.697 95.8991 253.697 95.8989 253.697 95.8987C253.697 95.175 253.079 94.5883 252.317 94.5883C251.555 94.5883 250.938 95.175 250.938 95.8987C250.938 95.8989 250.938 95.8991 250.938 95.8993V103.808H253.698V95.8993H253.697Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.182 118.719C255.182 118.719 255.182 118.719 255.182 118.719C255.182 117.916 253.896 117.265 252.31 117.265C250.723 117.265 249.438 117.916 249.438 118.719C249.438 118.719 249.438 118.719 249.438 118.719V127.491H255.184V118.719H255.182Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.026 118.719C227.026 118.719 227.026 118.719 227.026 118.719C227.026 117.916 225.74 117.265 224.154 117.265C222.567 117.265 221.281 117.916 221.281 118.719C221.281 118.72 221.281 118.722 221.281 118.724V127.491H227.028V118.719H227.026Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.539 95.8993C225.539 95.8991 225.539 95.8989 225.539 95.8987C225.539 95.175 224.922 94.5883 224.16 94.5883C223.398 94.5883 222.78 95.175 222.78 95.8987C222.78 95.8989 222.78 95.8991 222.78 95.8993H222.78V103.808H225.541V95.8993H225.539Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.08 72.5605C213.08 72.5604 213.08 72.5604 213.08 72.5603C213.08 71.8549 212.289 71.283 211.312 71.283C210.336 71.283 209.544 71.8549 209.544 72.5603C209.544 72.5604 209.544 72.5604 209.544 72.5605H209.544V80.2673H213.081V72.5605H213.08Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.235,
    cy: 14.4663,
    r: 1.08849,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.344 29.6358C265.635 29.5534 265.849 29.2859 265.849 28.9686C265.849 28.5857 265.538 28.2753 265.155 28.2753C264.772 28.2753 264.462 28.5857 264.462 28.9686C264.462 29.2892 264.68 29.5589 264.975 29.6383L262.132 44.2717H261.015V43.5301H261.005L260.5 41.1087L259.995 43.5301H259.991V44.2717H259.988V52.1225H259.985V49.6517H259.974L259.239 46.1274L258.504 49.6517H258.494V53.1345H258.514V55.8233L257.63 52.4905L256.436 56.9912H256.419V61.4384H256.419V132.413H273.903V60.3109H273.901V56.9912H273.886L272.692 52.4904L271.804 55.841V52.1225H271.801V49.6517H271.792L271.057 46.1274L270.332 49.6039V44.2717H270.331V43.5301H270.324L269.819 41.1087L269.314 43.5301H269.308V44.2717H268.188L265.344 29.6358Z",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.506 29.6365C211.798 29.555 212.012 29.2868 212.012 28.9685C212.012 28.5856 211.702 28.2752 211.319 28.2752C210.936 28.2752 210.626 28.5856 210.626 28.9685C210.626 29.2881 210.842 29.5572 211.136 29.6374L208.293 44.2716H207.174V43.5301H207.167L206.662 41.1086L206.157 43.5301H206.151V44.2716H206.144V49.6194L205.415 46.1269L204.681 49.6512H204.67V53.1341H204.67V55.8338L203.783 52.4905L202.59 56.9912H202.572V60.3107V61.4384V132.413H220.056V61.4384H220.058V56.9912H220.043L218.849 52.4904L217.96 55.8432V53.1341H217.978V49.6512H217.969L217.234 46.1269L216.499 49.6512H216.488V45.9218H216.493V43.5301H216.484L215.979 41.1086L215.474 43.5301H215.469V44.2716H214.349L211.506 29.6365Z",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.922 72.5604C266.922 72.5603 266.922 72.5603 266.922 72.5603C266.922 71.8548 266.13 71.283 265.154 71.283C264.177 71.283 263.386 71.8548 263.386 72.5603C263.386 72.5603 263.386 72.5603 263.386 72.5604V80.2671H266.923V72.5604H266.922Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.08 72.5605C213.08 72.5604 213.08 72.5604 213.08 72.5603C213.08 71.8549 212.289 71.283 211.312 71.283C210.336 71.283 209.544 71.8549 209.544 72.5603C209.544 72.5604 209.544 72.5604 209.544 72.5605H209.544V80.2673H213.081V72.5605H213.08Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.08 84.8933C213.08 84.8932 213.08 84.8932 213.08 84.8931C213.08 84.1877 212.289 83.6158 211.312 83.6158C210.336 83.6158 209.544 84.1877 209.544 84.8931C209.544 84.8932 209.544 84.8932 209.544 84.8933H209.544V92.6001H213.081V84.8933H213.08Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.922 84.8933C266.922 84.8933 266.922 84.8933 266.922 84.8933C266.922 84.1878 266.13 83.616 265.154 83.616C264.177 83.616 263.386 84.1878 263.386 84.8933C263.386 84.8933 263.386 84.8933 263.386 84.8933V92.6001H266.923V84.8933H266.922Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.08 97.2258C213.08 97.2258 213.08 97.2257 213.08 97.2257C213.08 96.5202 212.289 95.9484 211.312 95.9484C210.336 95.9484 209.544 96.5202 209.544 97.2257C209.544 97.2257 209.544 97.2258 209.544 97.2258H209.544V104.933H213.081V97.2258H213.08Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.922 97.2258C266.922 97.2257 266.922 97.2257 266.922 97.2257C266.922 96.5202 266.13 95.9484 265.154 95.9484C264.177 95.9484 263.386 96.5202 263.386 97.2257C263.386 97.2257 263.386 97.2257 263.386 97.2258V104.933H266.923V97.2258H266.922Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.08 109.558C213.08 109.558 213.08 109.558 213.08 109.558C213.08 108.852 212.289 108.281 211.312 108.281C210.336 108.281 209.544 108.852 209.544 109.558C209.544 109.558 209.544 109.558 209.544 109.558H209.544V117.265H213.081V109.558H213.08Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.922 109.558C266.922 109.558 266.922 109.558 266.922 109.558C266.922 108.852 266.13 108.281 265.154 108.281C264.177 108.281 263.386 108.852 263.386 109.558C263.386 109.558 263.386 109.558 263.386 109.558V117.265H266.923V109.558H266.922Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.08 121.891C213.08 121.891 213.08 121.891 213.08 121.891C213.08 121.185 212.289 120.614 211.312 120.614C210.336 120.614 209.544 121.185 209.544 121.891C209.544 121.891 209.544 121.891 209.544 121.891H209.544V129.598H213.081V121.891H213.08Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.922 121.891C266.922 121.891 266.922 121.891 266.922 121.891C266.922 121.185 266.13 120.613 265.154 120.613C264.177 120.613 263.386 121.185 263.386 121.891C263.386 121.891 263.386 121.891 263.386 121.891V129.598H266.923V121.891H266.922Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.483 152.028C114.691 152.542 114.752 153.237 113.915 153.661C108.737 138.544 105.569 118.667 99.6758 105.198C101.945 104.321 104.229 103.475 106.498 102.613C111.95 118.546 108.965 134.04 115.483 152.028Z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6328 150.471C84.7952 150.062 85.313 149.473 84.5058 149.004C94.0392 132.86 99.1409 121.946 98.0596 102.628C100.496 102.31 102.933 102.038 105.385 101.751C105.324 120.268 95.425 135.475 85.6328 150.471Z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.489 69.674C106.651 69.5984 105.631 70.1577 105.326 70.974C105.022 71.7903 105.646 72.6519 106.438 72.9391C107.23 73.2263 108.829 72.4101 109.133 71.5938C109.438 70.7775 108.555 69.7647 107.489 69.674Z",
    fill: "#2D334A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.705 69.9011C104.837 67.4825 101.959 65.3209 99.2632 65.5325C96.5525 65.7442 94.923 68.6011 95.121 71.1558C95.3189 73.7104 98.6084 77.1871 102.675 77.1569C105.385 77.1418 106.817 72.9697 105.705 69.9011Z",
    fill: "#2D334A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.046 74.5876C106.574 73.2271 105.036 72.0179 103.604 72.1388C102.157 72.2597 101.289 73.8469 101.411 75.2678C101.533 76.7039 103.848 78.6539 105.295 78.5329C106.741 78.412 107.64 76.3109 107.046 74.5876Z",
    fill: "#2D334A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.878 75.4334C104.975 77.7613 107.503 78.895 108.934 78.2299C110.366 77.5648 110.168 75.3578 109.072 73.0299C107.975 70.7021 106.254 70.0521 104.823 70.7172C103.391 71.3823 102.782 73.1055 103.878 75.4334Z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.844 74.103C102.844 74.103 102.631 72.3797 103.56 71.3065C104.473 70.2181 106.788 69.2658 108.25 71.0949C108.25 71.0949 109.164 72.4855 107.382 73.453C105.6 74.4204 105.539 73.3018 104.976 74.5716C104.412 75.8413 103.316 75.4786 103.225 75.7506L102.844 74.103Z",
    fill: "#2D334A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8963 131.771C87.8862 131.953 88.6781 132.648 89.5461 133.162C90.8558 133.933 92.4396 134.235 93.9473 134.039C94.9981 133.903 95.988 133.525 97.0083 133.268C98.6683 132.86 100.42 132.814 102.11 133.117C104.638 133.57 106.953 134.794 109.42 135.46C110.455 135.732 111.567 135.898 112.648 135.868C111.582 126.556 110.608 117.789 108.765 109.097C108.46 107.691 108.247 106.27 108.125 104.849C107.775 100.435 106.663 92.9226 107.349 91.5924C109.283 87.8133 108.445 88.2064 108.293 86.0448C108.141 83.868 108.11 81.782 107.09 80.8297C107.075 80.8146 107.059 80.7994 107.044 80.7843C106.176 79.968 104.912 79.832 103.8 80.2855C103.009 80.618 102.597 80.9808 100.831 83.5657C98.8358 86.5133 97.6175 98.8784 97.6175 98.8784C94.9524 111.077 90.5208 122.324 86.1958 131.756C86.4394 131.726 86.6679 131.741 86.8963 131.771Z",
    fill: "#8FCCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.7 75.7662L107.411 76.0081C107.381 76.3709 107.015 79.8627 106.634 81.1476C106.467 81.5255 105.766 81.586 105.081 81.2836C104.457 81.0116 104.061 80.5278 104.122 80.165C104.32 79.379 104.578 77.0511 104.7 75.7662Z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.126 90.7828C126.126 90.7828 130.668 89.9678 131.531 90.7393C132.394 91.5109 128.167 92.768 125.568 91.7675L126.126 90.7828Z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.271 92.4811C127.093 91.7335 126.856 91.0429 126.636 90.2427C119.224 90.3734 115.608 89.8991 111.6 87.081C110.065 86.2439 108.712 84.0372 107.921 83.0525L108.272 87.7818C109.548 88.6094 110.549 89.3582 111.775 90.0588C114.853 91.8093 118.36 92.311 127.271 92.4811Z",
    fill: "#8FCCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.766 148.036C114.766 148.036 114.766 154.068 120.34 155.292C120.34 155.292 121.787 155.745 119.944 155.987C118.101 156.229 115.223 155.625 114.324 154.687C114.324 154.687 113.807 156.637 113.609 156.048C113.426 155.458 111.477 148.747 111.477 148.747L114.766 148.036Z",
    fill: "#333436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9551 146.585C88.9551 146.585 84.295 150.47 86.9449 155.489C86.9449 155.489 87.5236 156.88 86.153 155.64C84.7823 154.4 83.3965 151.816 83.5488 150.531C83.5488 150.531 81.7061 151.377 82.0411 150.863C82.3762 150.349 86.3052 144.545 86.3052 144.545L88.9551 146.585Z",
    fill: "#333436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.163 76.4613C103.376 77.0204 104.214 77.5191 104.625 77.3679C105.036 77.2168 104.96 76.7182 104.746 76.159C104.533 75.5999 104.001 75.207 103.589 75.3581C103.178 75.5092 102.95 75.9021 103.163 76.4613Z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.9414,
    y: 119.521,
    width: 19.7204,
    height: 30.6007,
    transform: "rotate(-100.36 87.9414 119.521)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.6637,
    y: 101.916,
    width: 10.4942,
    height: 2.22023,
    transform: "rotate(-10.36 86.6637 101.916)",
    stroke: "#CACDCD",
    strokeWidth: 0.143771
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.9333,
    y: 100.038,
    width: 8.72124,
    height: 2.22023,
    transform: "rotate(-10.36 96.9333 100.038)",
    stroke: "#CACDCD",
    strokeWidth: 0.143771
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.3737,
    y: 105.792,
    width: 12.7269,
    height: 11.6106,
    transform: "rotate(-10.36 87.3737 105.792)",
    stroke: "#CACDCD",
    strokeWidth: 0.143771
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.0736,
    y1: 105.225,
    x2: 92.1875,
    y2: 116.788,
    stroke: "#CACDCD",
    strokeWidth: 0.143771
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4168,
    y1: 107.493,
    x2: 100.365,
    y2: 105.674,
    stroke: "#CACDCD",
    strokeWidth: 0.143771
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.8298,
    y1: 109.754,
    x2: 100.778,
    y2: 107.935,
    stroke: "#CACDCD",
    strokeWidth: 0.143771
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.2537,
    y1: 112.079,
    x2: 101.201,
    y2: 110.26,
    stroke: "#CACDCD",
    strokeWidth: 0.143771
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.6668,
    y1: 114.34,
    x2: 101.615,
    y2: 112.521,
    stroke: "#CACDCD",
    strokeWidth: 0.143771
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.985,
    y: 103.158,
    width: 0.0888925,
    height: 0.0888925,
    transform: "rotate(-10.36 111.985 103.158)",
    fill: "#76797C",
    stroke: "#76797C",
    strokeWidth: 0.0888925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.599,
    y: 102.891,
    width: 0.752396,
    height: 0.752396,
    transform: "rotate(-10.36 111.599 102.891)",
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.431,
    y: 105.585,
    width: 0.0888925,
    height: 0.0888925,
    transform: "rotate(-10.36 112.431 105.585)",
    fill: "#76797C",
    stroke: "#76797C",
    strokeWidth: 0.0888925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.044,
    y: 105.318,
    width: 0.752396,
    height: 0.752396,
    transform: "rotate(-10.36 112.044 105.318)",
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.413,
    y: 102.714,
    width: 0.0888925,
    height: 0.0888925,
    transform: "rotate(-10.36 114.413 102.714)",
    fill: "#76797C",
    stroke: "#76797C",
    strokeWidth: 0.0888925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.027,
    y: 102.447,
    width: 0.752396,
    height: 0.752396,
    transform: "rotate(-10.36 114.027 102.447)",
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.631,
    y1: 102.637,
    x2: 112.916,
    y2: 104.197,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.977,
    y1: 102.574,
    x2: 113.167,
    y2: 103.614,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.197,
    y1: 103.787,
    x2: 113.387,
    y2: 104.827,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.043,
    y1: 104.891,
    x2: 113.106,
    y2: 105.238,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.576,
    y1: 103.897,
    x2: 113.639,
    y2: 104.245,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.252,
    y1: 104.498,
    x2: 112.315,
    y2: 104.845,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.505,
    y1: 103.914,
    x2: 112.62,
    y2: 104.544,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.123,
    y1: 104.511,
    x2: 115.313,
    y2: 105.551,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.018,
    y1: 104.354,
    x2: 114.114,
    y2: 104.875,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.429,
    y1: 104.638,
    x2: 114.556,
    y2: 105.332,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.839,
    y1: 104.921,
    x2: 114.902,
    y2: 105.268,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.885,
    y1: 104.196,
    x2: 114.948,
    y2: 104.543,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.146,
    y1: 105.048,
    x2: 114.21,
    y2: 105.395,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.365,
    y1: 104.291,
    x2: 114.397,
    y2: 104.465,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.673,
    y1: 104.418,
    x2: 113.863,
    y2: 105.458,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.965,
    y1: 103.644,
    x2: 115.028,
    y2: 103.991,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.616,
    y1: 103.707,
    x2: 114.68,
    y2: 104.055,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.104,
    y1: 105.238,
    x2: 113.231,
    y2: 105.932,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.67,
    y1: 102.447,
    x2: 113.733,
    y2: 102.794,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.903,
    y1: 105.268,
    x2: 114.935,
    y2: 105.443,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.504,
    y1: 105.816,
    x2: 114.025,
    y2: 105.721,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.796,
    y1: 103.14,
    x2: 113.828,
    y2: 103.315,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.481,
    y1: 103.377,
    x2: 113.513,
    y2: 103.552,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.468,
    y1: 103.672,
    x2: 115.028,
    y2: 103.387,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.557,
    y1: 104.556,
    x2: 113.251,
    y2: 104.429,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.202,
    y1: 105.154,
    x2: 113.55,
    y2: 105.091,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.706,
    y1: 103.987,
    x2: 114.573,
    y2: 103.829,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.606,
    y1: 104.002,
    x2: 114.953,
    y2: 103.939,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.944,
    y1: 104.303,
    x2: 114.464,
    y2: 104.207,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.732,
    y1: 104.696,
    x2: 115.252,
    y2: 104.6,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.133,
    y1: 105.343,
    x2: 114.654,
    y2: 105.247,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.559,
    y1: 104.727,
    x2: 114.906,
    y2: 104.664,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.843,
    y1: 104.317,
    x2: 115.19,
    y2: 104.254,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.495,
    y1: 104.381,
    x2: 114.67,
    y2: 104.349,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.266,
    y1: 105.501,
    x2: 113.787,
    y2: 105.406,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.196,
    y1: 105.689,
    x2: 115.236,
    y2: 105.499,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.737,
    y1: 103.989,
    x2: 112.604,
    y2: 103.831,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.052,
    y1: 102.853,
    x2: 113.81,
    y2: 102.714,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.375,
    y1: 103.152,
    x2: 113.896,
    y2: 103.057,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.794,
    y1: 104.314,
    x2: 112.315,
    y2: 104.219,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.863,
    y1: 104.683,
    x2: 112.384,
    y2: 104.588,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.274,
    y1: 104.966,
    x2: 113.14,
    y2: 104.808,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.328,
    y1: 104.641,
    x2: 112.253,
    y2: 104.228,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.048,
    y1: 105.073,
    x2: 111.973,
    y2: 104.66,
    stroke: "#76797C",
    strokeWidth: 0.128638
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.5703,
    y: 113.461,
    width: 7.02634,
    height: 1.24767,
    rx: 0.623834,
    transform: "rotate(-100.36 89.5703 113.461)",
    fill: "#76797C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.2803,
    y: 102.398,
    width: 5.58167,
    height: 1.05067,
    rx: 0.525334,
    transform: "rotate(-10.36 87.2803 102.398)",
    fill: "#64686A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.6807,
    y: 100.497,
    width: 7.42034,
    height: 1.05067,
    rx: 0.525334,
    transform: "rotate(-10.36 97.6807 100.497)",
    fill: "#64686A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.2217,
    y: 101.312,
    width: 3.28334,
    height: 1.05067,
    rx: 0.525334,
    transform: "rotate(-10.36 93.2217 101.312)",
    fill: "#64686A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.75,
    y: 103.407,
    width: 6.56667,
    height: 1.05067,
    rx: 0.525334,
    transform: "rotate(-10.36 100.75 103.407)",
    fill: "#76797C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.077,
    y: 105.216,
    width: 7.81434,
    height: 0.788001,
    rx: 0.394,
    transform: "rotate(-10.36 101.077 105.216)",
    fill: "#76797C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.312,
    y: 106.508,
    width: 7.81434,
    height: 0.788001,
    rx: 0.394,
    transform: "rotate(-10.36 101.312 106.508)",
    fill: "#76797C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8076 108.129C98.8076 108.129 102.34 111.652 102.202 112.902C102.064 114.151 98.3225 111.178 97.5847 108.253L98.8061 108.129L98.8076 108.129Z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7798 108.874C99.1379 109.373 98.619 109.819 97.9277 110.366C89.3826 97.1533 91.1936 92.8682 101.162 81.7164C102.687 80.0105 105.699 82.5755 102.867 85.17C92.9231 94.2814 93.7468 96.5148 99.7789 108.872L99.7798 108.874Z",
    fill: "#8FCCCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_34588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 308,
    height: 162,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrdinancesReady);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ordinances-ready.0aae03fbfd0455e9c98ca5c2a6091fbd.svg";